export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-36 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20shot%20of%20elegant%20minimalist%20fashion%20boutique%20interior%20with%20clothing%20racks%20and%20natural%20light%2C%20cream%20walls%20and%20light%20wood%20floors%2C%20European%20luxury%20retail%20aesthetic%2C%20soft%20warm%20atmosphere%2C%20no%20text%20no%20logos%2C%20airy%20spacious%20composition&width=1800&height=800&seq=hbs-v2-cta-bg-main&orientation=landscape"
          alt="Hipobuy Spreadsheet - Commencez maintenant"
          className="w-full h-full object-cover"
          title="Hipobuy Spreadsheet CTA"
        />
      </div>
      <div className="absolute inset-0 z-[1] bg-foreground-950/50"></div>

      <div className="relative z-10 px-6 md:px-12 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-12 md:gap-16">
          <div>
            <p className="text-5xl md:text-7xl lg:text-8xl font-bold text-background-50 font-sans lowercase tracking-tight">
              hipobuy spreadsheet
            </p>
          </div>

          <div className="flex flex-col items-start lg:items-end gap-6 lg:max-w-sm">
            <p className="text-sm md:text-base text-background-50/80 font-sans leading-relaxed lg:text-right">
              Commencez à utiliser Hipobuy Spreadsheet aujourd'hui et reprenez le contrôle de vos finances. Accès gratuit et immédiat.
            </p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-3 bg-background-50 text-foreground-950 font-sans text-sm md:text-base font-medium px-7 py-3.5 rounded-full hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Accéder au modèle principal
              <span className="w-7 h-7 rounded-full bg-foreground-950 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                <i className="ri-arrow-right-line text-background-50 text-xs"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}